/**
 * [INPUT]: 依赖 React Router、framer-motion、AuthProvider、MainLayout、Login、Toaster
 * [OUTPUT]: 对外提供 App 根组件（认证守卫 + Provider 组装）
 * [POS]: src 浏览器应用根
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */

import { useEffect } from 'react'
import { BrowserRouter, Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import { LazyMotion, MotionConfig, domAnimation } from 'framer-motion'
import AuthProvider from '@/providers/AuthProvider'
import { useAuth } from '@/providers/AuthContext'
import MainLayout from '@/layouts/MainLayout'
import Login from '@/pages/Login'
import { Toaster } from '@/zinnercms-design-system/ui/sonner'
import { PageLoading } from '@/components/LoadingDots'

function AppContent() {
  const { isAuthenticated, loading, user } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (!loading && (!isAuthenticated || !user)) {
      if (location.pathname !== '/login') navigate('/login', { replace: true })
    }
  }, [isAuthenticated, user, loading, navigate, location.pathname])

  if (loading) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-sidebar text-foreground">
        <PageLoading message="加载中" />
      </div>
    )
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={isAuthenticated && user ? <Navigate to="/admin/dashboard" replace /> : <Login />}
      />
      <Route
        path="/*"
        element={isAuthenticated && user ? <MainLayout /> : <Navigate to="/login" replace />}
      />
    </Routes>
  )
}

export default function App() {
  return (
    <MotionConfig reducedMotion="user">
      <LazyMotion features={domAnimation} strict>
        <BrowserRouter>
          <AuthProvider>
            <AppContent />
            <Toaster />
          </AuthProvider>
        </BrowserRouter>
      </LazyMotion>
    </MotionConfig>
  )
}
